const createAccordion = content => `
    <section class="ui-accordion__row
                    js-accordion__row"
             data-accordion-row="odds"
    >
        <div class="ui-accordion__header
                    js-accordion__header
                    RC-accordion__header
                    RC-accordion__header_cardPage"
             data-test-selector="RC-accordion__title"
        >
            <span class="RC-accordion__contentName
                         RC-accordion__contentName_cardPage"
                  data-test-selector="RC-accordion__name"
            >
                Check Odds
            </span>
            <svg class="ui-icon
                        ui-icon_sizeMedium
                        ui-accordion__arrow
                        RC-accordion__arrow"
                 data-test-selector="RC-accordion__arrow">
                <use xlink:href="img/icons.svg#icon-down"/>
            </svg>
        </div>
        <div class="ui-accordion__content
                    js-accordion__content
                    RC-accordion__content
                    hidden"
            data-test-selector="RC-accordion__content"
        >
            ${content}
        </div>
    </section>
`;

export default createAccordion;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/helpers/createAccordion.js